<template>
    <div style="margin-top:8rem">
        <div class="token-gen__title--big">
            {{
                $t('paygo.tokenGenerator.bigTitle', {
                    i18nFallback: 'Generate PAYGo token for this installation',
                })
            }}
        </div>
        <div class="token-gen-container">
            <div class="token-gen__description">
                <div class="token-gen__title">
                    {{
                        $t('paygo.tokenGenerator.title', { i18nFallback: 'Select your token type' })
                    }}
                </div>
                <div class="token-gen__text">
                    {{
                        $t('paygo.tokenGenerator.text', {
                            i18nFallback:
                                'You can set your desired token time, add time to your current token or disable PAYGo mode for your installations. Input your generated code to the device to activate your token(s).',
                        })
                    }}
                </div>
            </div>
            <div class="token-gen__grid">
                <b class="token-gen__title--small token-gen__set__title">
                    {{ $t('paygo.tokenGenerator.setTime', { i18nFallback: 'Set time' }) }}
                </b>
                <div class="token-gen__text token-gen__set__description">
                    {{
                        $t('paygo.tokenGenerator.setTimeDescription', {
                            i18nFallback: 'Set the total token duration',
                        })
                    }}
                </div>
                <b class="token-gen__title--small token-gen__add__title">
                    {{ $t('paygo.tokenGenerator.addTime', { i18nFallback: 'Add time' }) }}
                </b>
                <div class="token-gen__text token-gen__add__description">
                    {{
                        $t('paygo.tokenGenerator.addTimeDescription', {
                            i18nFallback: 'Set the the time you wish to add to your current token',
                        })
                    }}
                </div>
                <b class="token-gen__title--small token-gen__disable__title">
                    {{ $t('paygo.tokenGenerator.disable', { i18nFallback: 'Disable PAYGo mode' }) }}
                </b>
                <div class="token-gen__text token-gen__disable__description">
                    {{
                        $t('paygo.tokenGenerator.disableDescription', {
                            i18nFallback:
                                'Select this when the installation has been fully paid off',
                        })
                    }}
                </div>

                <div class="token-gen-container__line--grouped token-gen__set__input">
                    <input
                        v-model.number="setTimeValue"
                        class="token-gen__input-number ng-pristine ng-valid ng-scope ng-not-empty ng-valid-required ng-touched"
                        type="text"
                        @keypress="isNumber($event)"
                    />
                    <div class="token-gen__text" style="margin-left:2rem; align-self:center">
                        {{ $t('paygo.tokenGenerator.days', { i18nFallback: 'days' }) }}
                    </div>
                </div>
                <div class="token-gen-container__line--grouped token-gen__add__input">
                    <div class="token-gen__plus" style="margin-right:2rem; align-self:center">
                        +
                    </div>
                    <input
                        v-model.number="addTimeValue"
                        class="token-gen__input-number ng-pristine ng-valid ng-scope ng-not-empty ng-valid-required ng-touched"
                        type="text"
                        @keypress="isNumber($event)"
                    />
                    <div class="token-gen__text" style="margin-left:2rem; align-self:center">
                        {{ $t('paygo.tokenGenerator.days', { i18nFallback: 'days' }) }}
                    </div>
                </div>
                <a
                    class="sg-btn sg-site token-gen__button token-gen__set__button"
                    :class="{ 'sg-disabled': setTimeValue <= 0 || setTimeValue >= 995 }"
                    data-i18n="profilesettings.delete_btn"
                    @click="SetTime()"
                >
                    {{ $t('paygo.tokenGenerator.setTime', { i18nFallback: 'Set time' }) }}
                </a>
                <a
                    class="sg-btn sg-site token-gen__button token-gen__add__button"
                    :class="{ 'sg-disabled': addTimeValue <= 0 || addTimeValue >= 995 }"
                    data-i18n="profilesettings.delete_btn"
                    @click="AddTime()"
                >
                    {{ $t('paygo.tokenGenerator.addTime', { i18nFallback: 'Add time' }) }}
                </a>
                <a
                    class="sg-btn sg-site token-gen__button token-gen__disable__button"
                    data-i18n="profilesettings.delete_btn"
                    @click="openConfirmDisableModal()"
                >
                    {{ $t('paygo.tokenGenerator.disable', { i18nFallback: 'Disable PAYGo mode' }) }}
                </a>

                <div class="token-gen__breakline token-gen__breakline--set" />
                <div class="token-gen__breakline token-gen__breakline--add" />
            </div>
        </div>
    </div>
</template>
<style></style>
<script>
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ngInject } from '@/vue/decorators/angular-interop';
import VrmDisablePaygoModal from '../components/modals/ConfirmDisablePaygoModal.vue';
@Component({
    components: {
        VrmDisablePaygoModal,
    },
})
@AngularLocaleBundle('paygo')
export default class VrmPaygoTokenGenerator extends Vue {
    @ngInject()
    ApiService;
    @ngInject()
    VrmModalService;

    setTimeValue = '';
    addTimeValue = '';

    @Prop()
    installation;
    @Prop()
    paygoSecrets;

    paygoPrivateKeyData = '';
    paygoStartingCode = 0;
    serialNumber = '';

    async mounted() {
        this.installation.then(site => {
            this.serialNumber = site.identifier;
        });
        this.paygoSecrets.then(key => {
            this.paygoPrivateKeyData = key.data.paygoPrivateKey;
            this.paygoStartingCode = key.data.paygoStartingCode;
        });
    }

    updateTokenHistory() {
        this.$emit('updateTokenHistory');
    }

    async SetTime(useCounter = false) {
        if (this.setTimeValue <= 0 || this.setTimeValue >= 995) return;
        const paygData = {
            serial: this.serialNumber,
            private_key: this.paygoPrivateKeyData,
            starting_code: this.paygoStartingCode,
            command: 'set_time',
            command_argument: this.setTimeValue,
            counter: useCounter ? 0 : undefined,
        };

        let paygResponse;
        //when device with new serial number for payg api us used to generate token, he payg api request to set counter manually
        //in case of serial number error counter:0 is used to set counter
        try {
            paygResponse = await this.ApiService.call2(
                'https://payg.victronenergy.com/api/token',
                paygData,
                { skipResultChecks: true, throwOnError: true },
            );
        } catch (error) {
            if (error.status == 400 && error.data.errors.serial) {
                this.SetTime(true);
                return;
            }
        }

        if (!paygResponse) return;
        const data = {
            code: paygResponse.data.token,
            tokenType: 'setTime',
            amount: 0,
            isPaid: 0,
            start: Date.now(),
            duration: this.setTimeValue,
        };

        await this.ApiService.call2(
            '/installations/' + this.$route.params.id + '/paygo-tokens',
            data,
        );
        this.updateTokenHistory();
    }

    async AddTime(useCounter = false) {
        if (this.addTimeValue <= 0 || this.addTimeValue >= 995) return;
        const paygData = {
            serial: this.serialNumber,
            private_key: this.paygoPrivateKeyData,
            starting_code: this.paygoStartingCode + '',
            command: 'add_time',
            command_argument: this.addTimeValue,
            counter: useCounter ? 0 : undefined,
        };
        let paygResponse;
        try {
            paygResponse = await this.ApiService.call2(
                'https://payg.victronenergy.com/api/token',
                paygData,
                { skipResultChecks: true, throwOnError: true },
            );
        } catch (error) {
            if (error.status == 400 && error.data.errors.serial) {
                this.AddTime(true);
                return;
            }
        }
        if (!paygResponse) return;
        const data = {
            code: paygResponse.data.token,
            tokenType: 'addTime',
            amount: 0,
            isPaid: 0,
            start: Date.now(),
            duration: this.addTimeValue,
        };

        await this.ApiService.call2(
            '/installations/' + this.$route.params.id + '/paygo-tokens',
            data,
        );
        this.updateTokenHistory();
    }

    openConfirmDisableModal() {
        this.VrmModalService.openVueModal(VrmDisablePaygoModal, { callback: this.DisablePAYGo });
    }

    async DisablePAYGo(useCounter = false) {
        const paygData = {
            serial: this.serialNumber,
            private_key: this.paygoPrivateKeyData,
            starting_code: this.paygoStartingCode,
            command: 'disable',
            counter: useCounter ? 0 : undefined,
        };
        let paygResponse;
        try {
            paygResponse = await this.ApiService.call2(
                'https://payg.victronenergy.com/api/token',
                paygData,
            );
        } catch (error) {
            if (error.status == 400 && error.data.errors.serial) {
                this.DisablePAYGo(true);
                return;
            }
        }
        if (!paygResponse) return;
        const data = {
            code: paygResponse.data.token,
            tokenType: 'disable',
            amount: 0,
            isPaid: 0,
            start: Date.now(),
            duration: 0,
        };
        await this.ApiService.call2(
            '/installations/' + this.$route.params.id + '/paygo-tokens',
            data,
        );
        this.updateTokenHistory();
    }

    isNumber(evt) {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            evt.preventDefault();
        } else {
            return evt;
        }
    }
}
</script>
